import React, { useEffect, useState, useRef } from "react";
import axios from '../../axios/axiosconf';
import { Redirect, useHistory } from "react-router";
import Header from "./Header";
import Footer from "./Footer";
import Aside from "./Aside";
import { Link } from "react-router-dom";
import CampoNit from "../custom/CampoNit";
import { escalarImagen } from "../../../resources/Helper";

function CuentaForm() {
    
    const [id, setId] = useState('');
    const [nombreEmpresa, setNombreEmpresa] = useState('');
    const [numColaboradores, setNumColaboradores] = useState('5');
    const [direccion, setDireccion] = useState('');
    const [tipoEmpresa, setTipoEmpresa] = useState('2');
    const [pais, setPais] = useState('Colombia');
    const [telefono, setTelefono] = useState('');
    const [identificacion, setIdentificacion] = useState('');
    const [tipoIdentificacion, setTipoIdentificacion] = useState('');
    const [plan, setPlan] = useState('');
    const [digitoVerificacion, setDigitoVerificacion] = useState();
    const [logo, setLogo] = useState();
    const [logoData, setLogodata] = useState();
    
    // Estados para horarios de agenda
    const [horaInicio, setHoraInicio] = useState('06:00:00');
    const [horaFin, setHoraFin] = useState('20:00:00');
    const [loadingHorario, setLoadingHorario] = useState(false);
    
    // Estado para pestañas
    const [pestanaActiva, setPestanaActiva] = useState('empresa'); // 'empresa' o 'horarios'
    
    const [errorlist, setErrorlist] = useState({});
    const [loading, setLoading] = useState();
    const [client, setClient] = useState([]);
    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState('');

    const [mensajePopup, setMensajePopup] = useState('Lorem ipsum dolor');
    const [claseMensajePopup, setClaseMensajePopup] = useState('alert alert-success mensaje-popup');

    const [headerCollapsed, setHeadercollapsed] = useState('collapse-hdr');
    let userdata = [];
    let history = useHistory();

    const [showToast, setShowToast] = useState(false);
    const [toastDelay, setToastDelay] = useState(4000);
    const [toastMessage, setToastMessage] = useState();

    const logoRef = useRef(0);
    const canvasRef = useRef(0);

    useEffect(() => {
      
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    
                    setId(response.data.client_id);
                    setNombreEmpresa(response.data.nombre);
                    setNumColaboradores(response.data.empleados);
                    setDireccion(response.data.direccion);
                    setTipoEmpresa(response.data.tipo_cliente);
                    setPais(response.data.pais);
                    setTelefono(response.data.telefono);
                    setIdentificacion(response.data.numero_documento);
                    setTipoIdentificacion(response.data.tipo_documento);
                    setPlan(response.data.plan);
                    setDigitoVerificacion(response.data.digito_verificacion);
                    setLogo(response.data.logo);

                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        // ✅ Cargar horarios de agenda
        axios.get('/horario-agenda')
            .then(response => {
                if (response.status === 200) {
                    // Si es el rango por defecto (00:00:00 - 23:59:00), usar valores por defecto
                    if (response.data.hora_inicio === '00:00:00' && response.data.hora_fin === '23:59:00') {
                        setHoraInicio('00:00:00');
                        setHoraFin('23:59:00');
                    } else {
                        setHoraInicio(response.data.hora_inicio);
                        setHoraFin(response.data.hora_fin);
                    }
                }
            })
            .catch(error => {
                console.log('Error cargando horarios:', error);
            });
    },[]);


    useEffect(() => {
        renderLogo();
    },[logo]);


    const handleSubmit = (e) => {
        e.preventDefault();

        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            nombre: nombreEmpresa,
            empleados: numColaboradores,
            direccion: direccion,
            tipo_cliente: tipoEmpresa,
            pais: pais,
            telefono: telefono,
            numero_documento: identificacion,
            tipo_documento: tipoIdentificacion,
            id: id,
            digito_verificacion: digitoVerificacion,
            logo: logo
        };


        axios.put('client', conf)
            .then(
                response => {
                    setErrorlist({});
                    setLoading(false);
                    setToastMessage('La Información De La Cuenta Ha Sido Modificada');
                    setToastDelay(4000);
                    setShowToast(true);
                }
            )
            .catch(
                err => {
                    console.log(err.response.data)

                    setErrorlist(err.response.data.errors);
                    setLoading(false);
                }
            )
    }


    const handleSubmitHorarios = (e) => {
        e.preventDefault();
        
        setLoadingHorario(true);

        const data = {
            hora_inicio: horaInicio,
            hora_fin: horaFin
        };

        axios.put('/horario-agenda', data)
            .then(response => {
                setLoadingHorario(false);
                setToastMessage('Horarios de agenda actualizados correctamente');
                setToastDelay(4000);
                setShowToast(true);
            })
            .catch(error => {
                setLoadingHorario(false);
                console.error('Error actualizando horarios:', error);
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrorlist(error.response.data.errors);
                } else {
                    alert('Error al actualizar los horarios');
                }
            });
    }


    function handleNit(valor, digitoVerificacion) {
        setIdentificacion(valor);
        setDigitoVerificacion(digitoVerificacion);
    }


    const agregarLogo = (files) => {

        let file = files[0];
        const f = URL.createObjectURL(file);
        
        var ctx = canvasRef.current.getContext("2d");
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        const img = new Image();

        img.onload = function() {
            const imgWidth = img.width;
            const imgHeight = img.height;

            const newWidth = canvasRef.current.width;

            const imagenEscalada = escalarImagen(img.width, img.height, canvasRef.current.width, canvasRef.current.height);
            const coordY = Math.floor((canvasRef.current.height - imagenEscalada.alto)/2);
            ctx.drawImage(img, 0, coordY, imagenEscalada.ancho, imagenEscalada.alto);
            //setLogo(canvasRef.current.toDataURL("image/png"));
            setLogo(canvasRef.current.toDataURL());
        }

        img.src = f;
    }


    const renderLogo = () => {

        var ctx = canvasRef.current.getContext("2d");
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        const img = new Image();

        img.onload = function() {
            const imgWidth = img.width;
            const imgHeight = img.height;

            const newWidth = canvasRef.current.width;

            const imagenEscalada = escalarImagen(img.width, img.height, canvasRef.current.width, canvasRef.current.height);
            const coordY = Math.floor((canvasRef.current.height - imagenEscalada.alto)/2);
            ctx.drawImage(img, 0, coordY, imagenEscalada.ancho, imagenEscalada.alto);
        }

        img.src = logo;
    }



    return (
      <div className="hold-transition">
        <Header client={client} />
        <Aside client={client} activelink="settings" />
        
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-8">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item" key="k0"><Link to="/home">Home</Link></li>
                                <li className="breadcrumb-item" key="k1"><Link to="/settings">Configuración</Link></li>
                                <li className="breadcrumb-item" key="k2">Cuenta De Usuario</li>
                            </ol>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-sm-8">
                            <h1 className="m-0">Configurar Empresa / Profesional Independiente</h1>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content" >
                <div className="container-fluid">

                    <div className="row">
                        <div className="col-md-11">
                            
                            {/* Pestañas */}
                            <ul className="nav nav-tabs" role="tablist">
                                <li className="nav-item">
                                    <a 
                                        className={`nav-link ${pestanaActiva === 'empresa' ? 'active' : ''}`}
                                        onClick={() => setPestanaActiva('empresa')}
                                        style={{ 
                                            cursor: 'pointer',
                                            color: pestanaActiva === 'empresa' ? '#fff' : '#495057'
                                        }}
                                    >
                                        <i className="fas fa-building mr-2"></i>
                                        Información de Empresa
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a 
                                        className={`nav-link ${pestanaActiva === 'horarios' ? 'active' : ''}`}
                                        onClick={() => setPestanaActiva('horarios')}
                                        style={{ 
                                            cursor: 'pointer',
                                            color: pestanaActiva === 'horarios' ? '#fff' : '#495057'
                                        }}
                                    >
                                        <i className="fas fa-clock mr-2"></i>
                                        Horarios de Agenda
                                    </a>
                                </li>
                            </ul>

                            {/* Contenido Pestaña Empresa */}
                            {pestanaActiva === 'empresa' && (
                            <form id="role-form" onSubmit={handleSubmit} autoComplete="off">
                                <div className="card">
                                    <div id="infobasica">
                                        <div className="card-body">

                                            
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="companyName">Nombre / Razon Social</label>
                                                            <input type="text" name="company-name" className="form-control" id="companyName" defaultValue={nombreEmpresa} onChange={(e) => setNombreEmpresa(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.nombre}
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="employees">Cantidad De Usuarios Que Requieres</label>
                                                            <select name="employees" id="employees" className="form-control" defaultValue={numColaboradores} onChange={(e) => setNumColaboradores(e.target.value)}>
                                                                <option value="5">1 - 3</option>
                                                                <option value="10">4 - 7</option>
                                                                <option value="20">8 - 11</option>
                                                                <option value="100">12 +</option>
                                                            </select>
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.empleados}
                                                            </div>
                                                        </div> 
                                                        <div className="form-group">
                                                            <label htmlFor="companyAddress">Dirección</label>
                                                            <input type="text" name="company-address" className="form-control" id="companyAddress" defaultValue={direccion} onChange={(e) => setDireccion(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.direccion}
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="tipoIdentificacion">Tipo Documento</label>
                                                            <select name="tipoIdentificacion" id="tipoIdentificacion" className="form-control" value={tipoIdentificacion} onChange={(e) => setTipoIdentificacion(e.target.value)}>
                                                                <option value="NIT">NIT</option>
                                                                <option value="CC">CC</option>
                                                                <option value="TI">TI</option>
                                                                <option value="CE">CE</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="companyType">Tipo De Empresa</label>
                                                            <select name="company-type" className="form-control" id="companyType" value={tipoEmpresa} onChange={(e) => setTipoEmpresa(e.target.value)}>
                                                                <option value="1">Consultorio Medico</option>
                                                                <option value="2">Consultorio Odontológico</option>
                                                                <option value="3">Clínica Estetica</option>
                                                                <option value="4">Clínica Dermatologica</option>
                                                                <option value="5">Centro De Vacunacion</option>
                                                                <option value="6">SPA</option>
                                                                <option value="4">Otro</option>
                                                            </select>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="country">País</label>
                                                            <select name="country" className="form-control" id="country" value={pais} onChange={(e) => setPais(e.target.value)}>
                                                                <option value="Colombia">Colombia</option>
                                                                <option value="Ecuador">Ecuador</option>
                                                                <option value="Peru">Perú</option>
                                                                <option value="Panama">Panamá</option>
                                                                <option value="Otro">Otro</option>
                                                            </select>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="phoneNumber">Número Celular</label>
                                                            <input type="text" name="phone-number" className="form-control" id="phoneNumber" placeholder="Número telefónico" defaultValue={telefono} onChange={(e) => setTelefono(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.telefono}
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <CampoNit valor={identificacion} digitoVerificacion={digitoVerificacion} onChange={handleNit} />
                                                        </div>
                                                        
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="tipoIdentificacion">Logo De La Empresa</label>
                                                            
                                                            <div className="contenedor-logo-cliente">
                                                                <div className="contenedor-imagen-logo">
                                                                    <canvas id="myCanvas" className="logo-cliente" width="240" height="180" ref={canvasRef}>
                                                                    </canvas>
                                                                    <input type="file" name="logoimg" id="logoimg" className="form-control logo-cliente-control" accept=".jpg, .png, .jpeg" onChange={(e) => agregarLogo(e.target.files)} />
                                                                </div>
                                                                <label htmlFor="logoimg" className="lbl-cargar-foto-perfil">Cargar Imagen</label>
                                                                <div className="invalid-feedback visible">
                                                                {errorlist.logo}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                        </div>
                                    </div>
                                </div>

                                <div className="row" style={{marginTop: '30px'}}>
                                    <div className="col-md-6">
                                        <button type="submit" className="btn btn-primary">
                                            Guardar Cambios&nbsp;
                                            {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                            
                                        </button>
                                    </div>
                                </div>

                            </form>
                            )}

                            {/* Contenido Pestaña Horarios */}
                            {pestanaActiva === 'horarios' && (
                            <form id="horarios-form" onSubmit={handleSubmitHorarios} autoComplete="off">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-title">
                                            <i className="fas fa-clock mr-2"></i>
                                            Configurar Horarios de Visualización de Agenda
                                        </h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="alert alert-info">
                                            <i className="fas fa-info-circle mr-2"></i>
                                            Configura el rango de horas que se mostrará en las vistas de agenda. 
                                            Si no configuras horarios, se mostrarán las 24 horas del día.
                                        </div>

                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="horaInicio">Hora de Inicio</label>
                                                    <input 
                                                        type="time" 
                                                        className="form-control" 
                                                        id="horaInicio" 
                                                        value={horaInicio.substring(0, 5)} 
                                                        onChange={(e) => setHoraInicio(e.target.value + ':00')}
                                                        required
                                                    />
                                                    {errorlist.hora_inicio && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.hora_inicio[0]}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="horaFin">Hora de Fin</label>
                                                    <input 
                                                        type="time" 
                                                        className="form-control" 
                                                        id="horaFin" 
                                                        value={horaFin.substring(0, 5)} 
                                                        onChange={(e) => setHoraFin(e.target.value + ':00')}
                                                        required
                                                    />
                                                    {errorlist.hora_fin && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.hora_fin[0]}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-8">
                                                <div className="alert alert-warning">
                                                    <strong>Ejemplo:</strong> Si configuras de 06:00 AM a 08:00 PM, 
                                                    la agenda solo mostrará ese rango de horas.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row" style={{marginTop: '30px'}}>
                                    <div className="col-md-6">
                                        <button type="submit" className="btn btn-primary">
                                            Guardar Horarios&nbsp;
                                            {loadingHorario ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                        </button>
                                    </div>
                                </div>

                            </form>
                            )}

                        </div>          
                    </div>

                </div>
            </section>
            
        </div>
        
        <div className={claseMensajePopup}>{mensajePopup}</div>

        <Footer showToast={showToast} delay={toastDelay} message={toastMessage} />
      </div>
    );
}
export default CuentaForm;